// @charset "utf-8";
import qrcodeComponent from '@/components/lib/qrcode'

const qrCode = {
    install: function (Vue) {
        Vue.component('qrCode', qrcodeComponent)
    }
}

export default qrCode



// WEBPACK FOOTER //
// ./src/lib/qrcode.js